<template>
<v-flex class="py-3 px-2" xs12 sm8 md6 lg5>
  <v-card class="pa-3 elevation-2">
    <v-layout row justify-center>
      <v-flex class="text-xs-center" xs12>
        <div class="headline">Sign Up</div>
      </v-flex>
    </v-layout>
    <v-stepper v-model="step" class="elevation-0">
      <v-stepper-header class="elevation-0">
        <v-stepper-step :complete="step > 1" step="1" editable></v-stepper-step>
        <v-divider class="mx-3"></v-divider>
        <v-stepper-step step="2"></v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content class="pa-0 text-xs-center" step="1">
          <v-card class="mb-2 elevation-0 px-1">
            <v-form v-model="infoValid">
              <v-layout row wrap justify-center>
                <v-flex class="pb-3 text-xs-center" xs12>
                  <div class="title">General Information</div>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="First Name"
                    v-model="user.firstName"
                    prepend-icon="person"
                    :rules="firstNameRules"
                    :error-messages="errors.firstNameMsgs"
                    validate-on-blur
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Last Name"
                    v-model="user.lastName"
                    prepend-icon="person"
                    :rules="lastNameRules"
                    :error-messages="errors.lastNameMsgs"
                    validate-on-blur
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Phone Number"
                    v-model="user.phone"
                    @blur="formatPhone"
                    prepend-icon="phone"
                    :rules="phoneRules"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card>
          <v-btn
            @click.native="formatInfo" 
            color="success" 
            :loading="loading" 
            :disabled="!infoValid || loading" 
            large 
            depressed
          >Continue</v-btn>
          <v-btn to="/sign-in" color="error" flat><b>Cancel</b></v-btn>
        </v-stepper-content>
        <v-stepper-content class="pa-0 text-xs-center" step="2">
          <v-card class="mb-2 elevation-0">
            <v-form v-model="accValid">
              <v-layout row wrap justify-center>
                <v-flex class="pb-3 text-xs-center" xs12>
                  <div class="title">Account Information</div>
                  <div class="subheading pt-1"><b>You:</b> {{user.firstName + ' ' + user.lastName + ', ' + user.phone}}</div>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="E-mail"
                    v-model="user.email"
                    prepend-icon="mail"
                    :rules="emailRules"
                    validate-on-blur
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Password"
                    v-model="user.password"
                    prepend-icon="lock"
                    :append-icon="visible ? 'visibility' : 'visibility_off'"
                    :append-icon-cb="() => (visible = !visible)"
                    :type="visible ? 'text' : 'password'"
                    :rules="passwordRules"
                    validate-on-blur
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Confirm Password"
                    v-model="user.pass2"
                    prepend-icon="lock"
                    :append-icon="visible2 ? 'visibility' : 'visibility_off'"
                    :append-icon-cb="() => (visible2 = !visible2)"
                    :type="visible2 ? 'text' : 'password'"
                    :rules="pass2Rules"
                    :error-messages="errors.pass2Msgs"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card>
          <v-btn 
            @click.native="signUp"
            color="success" 
            :loading="loading" 
            :disabled="!accValid || loading" 
            large 
            depressed
          >Sign Up</v-btn>
          <v-btn @click.native="step = 1" color="error" flat><b>Back</b></v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-card>
</v-flex>
</template>

<script>
// let Filter = require('bad-words')
// let filter = new Filter()
export default {
  data: () => ({
    entering: true,
    step: 1,
    infoValid: false,
    accValid: false,
    loading: false,
    visible: false,
    visible2: false,
    user: {
      type: 'Student',
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      password: '',
      pass2: '',
      data: '',
      displayName: '',
      dateCreated: null
    },
    errors: {
      firstNameMsgs: [],
      lastNameMsgs: [],
      pass2Msgs: []
    },
    firstNameRules: [
      v => !!v || 'First name is required',
      v => v.length > 1 || 'First name must be longer than one letter',
      v => /^[a-zA-Z ,.'-]+$/i.test(v) || 'First name must be valid'
    ],
    lastNameRules: [
      v => !!v || 'Last name is required',
      v => v.length > 1 || 'Last name must be longer than one letter',
      v => /^[a-zA-Z ,.'-]+$/i.test(v) || 'Last name must be valid'
    ],
    phoneRules: [
      v => !!v || 'Phone number is required',
      v => (v.length <= 13 && v.length >= 10) || 'Please enter a valid U.S. phone number with area code',
      v => /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(v) || 'Please enter a valid U.S. phone number with area code'
    ],
    emailRules: [
      v => !!v || 'Email Address is required',
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
    ],
    passwordRules: [
      v => !!v || 'Password is required',
      v => v.length >= 6 || 'Password must be 6 characters or more'
    ],
    pass2Rules: [
      v => !!v || 'Please confirm your password'
    ]
  }),
  beforeMount () {
    this.load()
  },
  methods: {
    load () {
      let appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.$store.getters.user) {
        appMsg.msg = 'You are already signed in'
        this.$store.dispatch('showAppMsg', appMsg)
        this.$router.push('/')
      } else this.entering = false
    },
    signUp () {
      this.errors.pass2Msgs = []
      if (this.user.password === this.user.pass2) {
        this.loading = true
        let userRoute = ''
        this.user.firstName = this.$store.getters.capitalize(this.user.firstName)
        this.user.lastName = this.$store.getters.capitalize(this.user.lastName)
        this.user.email = this.user.email.toLowerCase()
        this.user.data = this.user.firstName.toLowerCase() + ' ' + this.user.lastName.toLowerCase() + ' '
        this.user.data += this.user.email.toLowerCase() + ' ' + this.user.type.toLowerCase()
        this.user.displayName = this.user.firstName + ' ' + this.user.lastName[0]
        this.$store.dispatch('signUp', this.user).then(() => {
          let appMsg = {
            type: 'success',
            msg: 'Signed up, you may now use your account.'
          }
          this.$store.dispatch('showAppMsg', appMsg)
          userRoute = this.$store.getters.userRoute
          if (userRoute !== '') {
            this.$store.dispatch('setUserRoute', '')
            this.$router.push(userRoute)
          } else if (this.$store.getters.user.type === 'Admin') this.$router.push('/dashboard')
          else this.$router.push('/my-courses')
          this.loading = false
        }).catch((err) => {
          let appMsg = {
            type: 'error',
            msg: err.message
          }
          this.$store.dispatch('showAppMsg', appMsg)
          this.loading = false
        })
      } else {
        this.errors.pass2Msgs.push('Passwords do not match')
        setTimeout(() => {
          this.errors.pass2Msgs = []
        }, 7000)
      }
    },
    formatInfo () {
      // let errs = false
      // if (filter.isProfane(this.user.firstName) || filter.isProfaneLike(this.user.firstName)) {
      //   this.errors.firstNameMsgs.push('That first name is not allowed')
      //   setTimeout(() => {
      //     this.errors.firstNameMsgs = []
      //   }, 7000)
      //   errs = true
      // } else this.errors.firstNameMsgs = []
      // if (filter.isProfane(this.user.lastName) || filter.isProfaneLike(this.user.lastName)) {
      //   this.errors.lastNameMsgs.push('That last name is not allowed')
      //   setTimeout(() => {
      //     this.errors.lastNameMsgs = []
      //   }, 7000)
      //   errs = true
      // } else this.errors.lastNameMsgs = []
      this.user.firstName = this.$store.getters.capitalize(this.user.firstName.toLowerCase())
      this.user.lastName = this.$store.getters.capitalize(this.user.lastName.toLowerCase())
      this.step = 2
    },
    formatPhone () {
      const digit = this.$store.getters.reg.digit
      let formatted = ''
      for (let c of this.user.phone) {
        if (digit.test(c)) {
          if (formatted.length === 0) formatted += '('
          if (formatted.length === 4) formatted += ')'
          if (formatted.length === 8) formatted += '-'
          formatted += c
        }
      }
      this.user.phone = formatted
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/auth/SignUp.vue